<template>
	<div class="about-bg">
		<van-row class="userdata-container">
			<van-col span="24">
				<van-col span="24" class="fix userdata-line userdata-line-image">
					<div class="fl userdata-line-left">头像</div>
					<div class="fr fix">
						<div class="fl">
							<img class="userdata-defaultimg" :src="userinfo.avatar">
						</div>
						<van-image class="userdata-moreicon" src="../../../static/images/tiaozhuan.png" />
					</div>
				</van-col>
				<van-col span="24" class="userdata-line userdata-line-flex">
					<div class="userdata-line-left">昵称</div>
					<div class="fl">
						<div class="userdata-editarea">{{userinfo.nickname}}</div>
					</div>
					<van-image class="userdata-moreicon" src="../../../static/images/tiaozhuan.png" />
				</van-col>
				<van-col span="24" class="userdata-line userdata-line-flex">
					<div class="userdata-line-left">签名</div>
					<div class="fl">
						<div class="userdata-editarea userdata-editarea-signature">{{userinfo.bio}}</div>
					</div>
					<van-image class="userdata-moreicon" src="../../../static/images/tiaozhuan.png" />
				</van-col>
				<van-col span="24" class="userdata-line userdata-line-flex">
					<div class="userdata-line-left">性别</div>
					<div class="fl">
						<div class="userdata-editarea">{{gender == 0 ? '女':'男'}}</div>
					</div>
					<van-image class="userdata-moreicon" src="../../../static/images/tiaozhuan.png" />
				</van-col>
				<van-col span="24" class="userdata-line userdata-line-flex">
					<div class="userdata-line-left">手机号</div>
					<div class="fl">
						<div class="userdata-editarea">{{userinfo.mobile}}</div>
					</div>
					<van-image class="userdata-moreicon" src="../../../static/images/tiaozhuan.png" />
				</van-col>
			</van-col>
		</van-row>
		<div class="userdata-btn" @click="editData">编辑</div>
	</div>
</template>

<script>
	export default{
		components:{
			
		},
		data(){
			return{
				userinfo: [],
				gender: ''
			}
		},
		created(){
			let that = this;
			// 百度统计
			let _hmt = _hmt || [];
			(function() {
			  //每次执行前，先移除上次插入的代码
			  document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
			  let hm = document.createElement("script");
			  hm.src = "https://hm.baidu.com/hm.js?5bf14d717bf0afb01060aea203da42c2";
			  hm.id = "baidu_tj";
			  let s = document.getElementsByTagName("script")[0]; 
			  s.parentNode.insertBefore(hm, s);
			})();
			let formdata = new FormData();
			formdata.append('user_id', localStorage.getItem('userId'));
			formdata.append('token', localStorage.getItem('token'));
			that.$axios.post('http://sls.zhishen.net.cn/api/User/getUserInfo', formdata)
			.then(function (res) {
				that.userinfo = res.data.userinfo
				that.gender = res.data.userinfo.gender
			})
			.catch(function (error) {
				console.log(error);
			});
			document.title = "个人资料"
		},
		methods:{
			editData(){
				this.$router.push({path: '/editdata'});
			}
		}
	}
</script>

<style>
	@import url("../../assets/css/personal.css");
</style>



// WEBPACK FOOTER //
// src/view/personal/userdata.vue